export class Conf {
  // static CDNBASEURL = ;
  //static APIBASEURL = 'http://localhost:54250/';
  static APIBASEURL = 'https://api.nfksber.ru/';
    //'https://localhost:44387/';
    //'https://api.nfksber.ru/';
}
